import type { SkillDto } from '@terra/shared-contracts-ai-skills';
import type { SkillDraft } from '../store/skillDraftsStore';

export function getDraftFromSkill(skill: SkillDto | null): SkillDraft {
  const seedVersion = skill?.draftVersion ?? skill?.publishedVersion ?? null;
  return {
    slug: skill?.slug ?? '',
    name: seedVersion?.frontmatter.name ?? '',
    description: seedVersion?.frontmatter.description ?? '',
    body: seedVersion?.body ?? '',
  };
}
